import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const legal_notice =
  'This system is the property of Accenture and is to be used in accordance with applicable Accenture Policies.  Unauthorized access or activity is a violation of Accenture Policies and may be a violation of law.  Use of this system constitutes consent to monitoring for unauthorized use, in accordance with Accenture Policies, local laws, and regulations.  Unauthorized use may result in penalties including, but not limited to, reprimand, dismissal, financial penalties, and legal action.';

export default function TermsModal(props) {
  const type = props.type || 'legal notice';
  return (
    <Modal {...props} aria-labelledby='contained-modal-title-vcenter' centered>
      <Modal.Body closeButton>
        <h5 style={{ fontWeight: 600 }}>
          {type.includes('legal') ? 'Legal Notice' : 'Terms of service'}
        </h5>
        <span
          style={{ display: 'block', margin: '1rem 0', fontSize: '0.9rem' }}
        >
          {type.includes('legal') ? legal_notice : legal_notice}
        </span>
        <Button onClick={props.onHide} style={{ float: 'right' }}>
          Close
        </Button>
      </Modal.Body>
    </Modal>
  );
}
